import type { CSSProperties, ReactNode } from 'react';

export function Skeleton({ w = '100%', h = 16, r, style }: { w?: number | string; h?: number | string; r?: number; style?: CSSProperties }): ReactNode {
  return <span className="skeleton" aria-hidden="true" style={{ width: w, height: h, ...(r !== undefined ? { borderRadius: r } : {}), ...style }} />;
}

export function SkeletonTiles({ count = 6, h = 112 }: { count?: number; h?: number }): ReactNode {
  return (
    <div className="tile-grid" aria-busy="true" aria-label="Loading">
      {Array.from({ length: count }, (_, i) => (
        <Skeleton key={i} h={h} r={22} />
      ))}
    </div>
  );
}
